import PreviewSectionCard from './PreviewSectionCard';

const rowClasses = 'flex items-start justify-between gap-4 py-3 border-b border-border-light last:border-b-0';

const nameClasses = 'text-sm font-semibold text-content m-0';

const descriptionClasses = 'text-sm text-subtle m-0 mt-0.5 max-w-md';

const PotentialCareCategoriesCard = ({ categories }) => (
    <PreviewSectionCard
        title="Potential Care Categories"
    >
        <div>
            {categories.map((category) => (
                <div key={category.name} className={rowClasses}>
                    <div className="min-w-0">
                        <p className={nameClasses}>{category.name}</p>
                        {category.description && <p className={descriptionClasses}>{category.description}</p>}
                    </div>
                </div>
            ))}
        </div>
    </PreviewSectionCard>
);

export default PotentialCareCategoriesCard;
